import gql from 'graphql-tag'

export const demoTokenCreate = gql`
  mutation demoTokenCreate($data: DemoTokenCreateInput!) {
    demoTokenCreate(input: $data) {
      success
    }
  }
`
